import type Location from 'garaje/models/location';
import type FeatureFlagsService from 'garaje/services/feature-flags';

/**
 * Whether the current user can sign out a visitor entry, given their edit / sign-out
 * abilities and the location's `employeeSignOutEnabled` configuration.
 *
 * When the host-sign-out restriction is on at the location (FF enabled AND
 * `employeeSignOutEnabled === false`), only the explicit sign-out permission
 * authorizes. Otherwise either `canEdit` or `canSignOut` authorizes.
 */
export function canSignOutEntry({
  canEdit,
  canSignOut,
  featureFlags,
  location,
}: {
  canEdit: boolean;
  canSignOut: boolean;
  featureFlags: FeatureFlagsService;
  location: Location | null | undefined;
}): boolean {
  if (
    featureFlags.isEnabled('visitors-disabled-sign-out') &&
    location?.visitorsConfiguration?.employeeSignOutEnabled === false
  ) {
    return canSignOut;
  }
  return canEdit || canSignOut;
}
